import { render, staticRenderFns } from "./MerchantAccessCard.vue?vue&type=template&id=55364101&"
import script from "./MerchantAccessCard.vue?vue&type=script&lang=js&"
export * from "./MerchantAccessCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports